module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Turnier umbenennen")])]), _vm._v(" "), _c('section', [_c('custom-form', {
    attrs: {
      "fields": [{
        name: 'name',
        type: 'text',
        title: 'Name'
      }],
      "submitLabel": "Speichern",
      "url": ("tournament/" + (_vm.$route.params.id) + "/rename")
    },
    on: {
      "submitted": _vm.onRenamed
    },
    model: {
      value: (_vm.tournament),
      callback: function($$v) {
        _vm.tournament = $$v
      },
      expression: "tournament"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01344158","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tournament-rename.vue
// module id = 217
// module chunks = 0